import classNames from 'classnames';
import React from 'react';

import {StringIDFolder} from 'constants/FolderConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {SidepanelItemSource, SourceSummary} from 'constants/SourceConstants';
import FinderUtil from 'file-browser/FinderUtil';
import {ListableItem} from 'search/SearchConstants';
import APIUtil from 'util/APIUtil';
import FolderDropTarget from 'util/drag-and-drop/FolderDropTarget';
import OptionalFileDragTarget from 'util/drag-and-drop/OptionalFileDragTarget';

export interface DragAndDropSidepanelItemWrapperProps {
  canInteract: boolean;
  children: React.ReactNode;
  finderId?: string | null;
  result: ListableItem | SidepanelItemSource;
  shouldCaptureDrop: boolean;
}

function folderFromResult(result: DragAndDropSidepanelItemWrapperProps['result']): StringIDFolder | null {
  switch (APIUtil.apiIdToType(result.id)) {
    case ModelTypeConstants.FOLDER: {
      return result as StringIDFolder;
    }
    case ModelTypeConstants.SOURCE: {
      return FinderUtil.sourceToRootFolder(result as SourceSummary);
    }
    default: {
      return null;
    }
  }
}

/**
 * A light wrapper for SidepanelItem with drag and drop functionality.
 */
export default function DragAndDropSidepanelItemWrapper(
  props: DragAndDropSidepanelItemWrapperProps
): JSX.Element {
  return (
    <FolderDropTarget
      folder={folderFromResult(props.result)}
      className={classNames('sidepanelItemDNDWrapper', {'is-interacting-allowed': props.canInteract})}
      shouldCaptureDrop={props.shouldCaptureDrop}
    >
      <OptionalFileDragTarget component="div" result={props.result} enabled={true} finderId={props.finderId}>
        {props.children}
      </OptionalFileDragTarget>
    </FolderDropTarget>
  );
}
